var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader'):_c('div',{ref:"container",staticClass:"container",attrs:{"data-aos":"fade-right","data-aos-anchor-placement":"top-bottom","data-aos-duration":"800"}},[_c('breadcrumb',{attrs:{"links":[
			{ name: _vm.$t('breadcrumbs.home'), path: { name: 'home' } },
			{ name: _vm.$t('breadcrumbs.branches') },
			{ name: _vm.branchName },
		]}}),_c('h1',{staticClass:"title-page"},[_vm._v(_vm._s(_vm.$t("branches.title")))]),_vm._l((_vm.branchesArr),function(branch,i){return _c('branche-view',{key:i,staticClass:"branche",attrs:{"branch":branch}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }